// extracted by mini-css-extract-plugin
module.exports = {"close":"Original_close__5uIen","inner":"Original_inner__i6snK","text":"Original_text__Mu9ax","mobile":"Original_mobile__5XyZs","desktop":"Original_desktop__Jf6yL"};